import React from 'react';
import { useEmployeeAttendance } from '../../hooks/useEmployeeAttendance';
import { EmployeeAttendancePage } from './EmployeeAttendancePage';
import { EmployeeAttendanceMode } from '../../config/employeeAttendance';
import { Box } from '@mui/material';

export const EmployeeAttendancePhone = () => {
  const employeAttendanceState = useEmployeeAttendance();

  return (
    <Box
      sx={{
        pt: { xs: 2, md: 10 },
        position: { md: 'fixed', xs: 'static' },
        top: 0,
        left: 0,
        overflow: 'hidden',
        bgcolor: 'grey.100',
        height: '100vh',
        width: '100%',
      }}
    >
      <Box
        sx={{
          p: { xs: 1, md: 3 },
          width: { xs: '95%', md: '950px' },
          mx: 'auto',
          height: '95%',
          bgcolor: 'white',
          borderRadius: 2,
        }}
      >
        <EmployeeAttendancePage employeAttendanceState={employeAttendanceState} mode={EmployeeAttendanceMode.PHONE} />
      </Box>
    </Box>
  );
};
